import { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dep
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { Paths } from '../constants/Paths';
import { IFRAME_MESSAGE_TYPES } from '../constants/IFrameMessages';
import { trackInteraction, trackPageView } from '../utils/usageTracker';
import { Metrics } from '../utils/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UpdatePaymentMethod() {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const updatePaymentUrl = params.get('url');
  useEffect(() => {
    trackPageView('update-payment-method');
  }, []);
  if (!updatePaymentUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.SUBSCRIPTIONS
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    flexGrow: 1,
    children: [/*#__PURE__*/_jsx(Flex, {
      paddingInline: "600",
      paddingBlock: "400",
      backgroundColor: "fill-surface-default",
      children: /*#__PURE__*/_jsxs(Breadcrumbs, {
        flush: false,
        children: [/*#__PURE__*/_jsx(Link, {
          onClick: () => history.push(Paths.SUBSCRIPTIONS),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "updatePaymentMethod.breadcrumb.subscriptions"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "updatePaymentMethod.breadcrumb.updatePaymentMethod"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(IFrame, {
      src: updatePaymentUrl,
      onReady: () => {},
      onMessage: msg => {
        var _msg$payload;
        if (((_msg$payload = msg.payload) === null || _msg$payload === void 0 ? void 0 : _msg$payload.type) === IFRAME_MESSAGE_TYPES.SUCCESS) {
          Metrics.counter('payment-method-updated').increment();
          trackInteraction('payment-method-updated');
          history.push(`${Paths.SUBSCRIPTIONS}?paymentMethodUpdated=true`);
        }
      },
      iframePassthruProps: {
        style: {
          border: 'none',
          width: '100%',
          flexGrow: 1,
          height: 'calc(100vh - 120px)'
        },
        title: 'Update Payment Method'
      }
    })]
  });
}